export const BACKGROUND_CONTENT = {
  night: {
    background: 'night',
  },
  morning: {
    background: 'morning',
  },
  day: {
    background: 'day',
  },
  afternoon: {
    background: 'afternoon',
  },
  evening: {
    background: 'night',
  },
};

export type TimeOfDayType = 'night' | 'day' | 'morning' | 'afternoon' | 'evening';

export function TimeOfDay(): TimeOfDayType {
  const hours = new Date().getHours();
  if (hours >= 5 && hours <= 9) {
    return 'morning';
  }
  if (hours >= 10 && hours <= 16) {
    return 'day';
  }
  if (hours >= 17 && hours <= 19) {
    return 'afternoon';
  } 
  if (hours >= 20 && hours <= 23) {
    return 'evening';
  }
  return 'night';
}
